import { normalizeChartQueryArgs, resolveChartIntervalSeconds } from './live-bucket-core.js';

interface LiveChartRequestArgs {
  readonly interval?: string;
  readonly from?: string;
  readonly to?: string;
  readonly liveWindowSeconds?: string;
  readonly paginate?: boolean;
}

/** The cache owns a rolling window; REST bounds are resolved only when a fetch is needed. */
export function resolveLiveChartRequestArgs<T extends LiveChartRequestArgs>(
  args: T,
  nowMs = Date.now(),
): T {
  if (args.liveWindowSeconds === undefined) return args;
  const normalized = normalizeChartQueryArgs(args);
  const seconds = normalized.liveWindowSeconds;
  const width = resolveChartIntervalSeconds(normalized);
  if (seconds === undefined || width === null || args.paginate === true) {
    throw new Error('chart live window requires a finite non-paginated resolution');
  }
  const anchor = Math.floor(nowMs / 60_000) * 60;
  return {
    ...args,
    from: new Date((anchor - seconds) * 1000).toISOString(),
    to: new Date((Math.floor(anchor / width) + 1) * width * 1000).toISOString(),
  };
}
